import { createApp } from 'vue'
import Gebelik from './Gebelik.vue'
import './assets/global.css'

createApp(Gebelik).mount('#gebelik')
